import Vue from 'vue';
import router from './router';
import store from '@/store/index';
import RetailerSearch from './components/Retailer/RetailerSearch.vue';
import Category from './components/Category/Category.vue';
import ProductTabs from './components/Product/ProductTabs/ProductTabs.vue';
import Configurator from './components/Product/Configurator/Configurator.vue';
import ConfigBuyButton from './components/Product/Configurator/ConfigBuyButton.vue';
import Complement from './components/Product/Complement.vue';
import ProductList from './components/Category/ProductList.vue';
import ResponsiveVideos from './components/Blocks/ResponsiveVideos.vue';
import ResponsiveVideoImage from './components/Blocks/ResponsiveVideoImage.vue';
import ReadMore from './components/ReadMore.vue';
import ProductListing from './components/Blocks/ProductListing.vue';
import UpSellProductListing from './components/Checkout/UpSellProductListing.vue';
import DoorFamilyCategory from './components/Category/DoorFamilyCategory.vue';
import CatalogOrder from './components/Catalog/CatalogOrder.vue';
import FilterSorting from './components/Filter/FilterSorting.vue';
import FaqList from './components/Blocks/FaqList.vue';
import InspirationListing from './components/Blocks/InspirationListing.vue';
import InspirationList from './components/Inspiration/InspirationList.vue';
import MediaDownloadList from './components/MediaDownload/MediaDownloadList.vue';
import ProductListBlock from './components/Blocks/ProductListBlock.vue';
import MasonryGrid from './components/Inspiration/MasonryGrid.vue';
import ImageHotspots from './components/Inspiration/ImageHotspots.vue';
import EnergyLabel from './components/Product/EnergyLabel.vue';
import NewsTicker from './components/NewsTicker.vue';
import RetailerMap from './components/Retailer/RetailerMap.vue';
import RetailerMap2 from './components/Retailer/RetailerMap2.vue';
import RetailerOpeningHours from './components/Retailer/RetailerOpeningHours.vue';
import RetailerMeetingBooking from './components/Retailer/RetailerMeetingBooking.vue';
import ContactForm from './components/Blocks/ContactForm.vue';
import ContactFormV2 from './components/Blocks/ContactFormV2.vue';
import OpenProductTab from './components/Product/ProductTabs/OpenProductTab.vue';
import Outlets from './components/SideboardGallery/Outlets.vue';
import References from './components/SideboardGallery/References.vue';
import RetailerExhibits from './components/Blocks/RetailerExhibits.vue';
import QuickSearch from './components/Search/QuickSearch.vue';
import VueResizeText from 'vue-resize-text';
import VueDragscroll from 'vue-dragscroll';
import VueCarousel from 'vue-carousel';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueLodash from 'vue-lodash';
import chunk from 'lodash/chunk';
import concat from 'lodash/concat';
import VueMasonry from 'vue-masonry-css';
import { websiteText } from './mixins/websiteTexts';
import { getMissingImage } from './mixins/getMissingImage';
import { htmlDecode } from './mixins/html';
import { commonMethod } from './mixins/commonMethod';
import { blFormatPrice } from './mixins/blFormatPrice';
import VModal from 'vue-js-modal';
import ImageWithHotspots from './components/Blocks/ImageWithHotspots.vue';
import BuyButtonContainer from './components/Cart/BuyButtonContainer.vue';
import Checkout from './components/Checkout/Checkout.vue';
import CheckoutB2c from './components/Checkout/CheckoutB2C.vue';
import MiniCart from './components/MiniCart/MiniCart.vue';
import CtaInputField from './components/Blocks/CallToActions/CtaInputField.vue';
import OrderConfirmationB2c from './components/Checkout/OrderConfirmationB2C.vue';
import ReturnForm from './components/Blocks/ReturnForm.vue';
import Message from './components/Message.vue';
import ProductImageSlider from './components/Product/ProductImageSlider.vue';
import FitsWithDrawer from './components/Product/FitsWithDrawer.vue';
import BlogList from './components/Blog/BlogList.vue';
import DataLayer from './components/DataLayer.vue';
import ProductSampleForm from './components/Blocks/ProductSampleForm.vue';
import DiscountCodeForm from './components/Blocks/DiscountCodeForm.vue';
import DiscountCodeConsume from './components/Blocks/DiscountCodeConsume.vue';
import SimulatorSummary from './components/SimulatorSummary/SimulatorSummary.vue';
import SingleSelectLink from './components/SingleSelectLink.vue';
import ItemsList from './components/Product/ProductTabs/TabContent/ItemsList.vue';
import BusinessCentralLoader from './components/BusinessCentralLoader.vue';
import BusinessCentralLoaderV2 from './components/BusinessCentralLoaderV2.vue';
import CollapsableMenu from './components/Blocks/CollapsableMenu/CollapsableMenu.vue';
import VimeoVideoModalToggle from './components/VimeoVideoModalToggle.vue';
import EverydayTrafficLight from './components/Blocks/EverydayTrafficLight.vue';
import EverydayBar from './components/EverydayBar.vue';
import MultipleImages from './components/MultipleImages/MultipleImages.vue';
import SimpleNewsList from './components/SimpleNewsList.vue';
import CartItemsCount from './components/MiniCart/CartItemsCount.vue';
import ProductQuickReferenceGuide from './components/Blocks/ProductQuickReferenceGuide.vue';
import RotCalculator from './components/Blocks/RotCalculator/RotCalculator.vue';

import { ValidationProvider, ValidationObserver } from 'vee-validate';

import 'spin.js/spin.css';
import '../scss/main.scss';
import { head } from 'lodash';

Vue.config.productionTip = false;

let googleMapsApiKey = '';
// @ts-ignore
if (window.__litium && window.__litium.constants && window.__litium.constants.countries[0]) {
    // @ts-ignore
    switch (window.__litium.constants.countries[0].value) {
        case 'NO':
            googleMapsApiKey = 'AIzaSyCmxkLbRkVLIkKrlo2Qncfo-vKNfOGdo6E';
        case 'SE':
            defualt: googleMapsApiKey = 'AIzaSyAO-TyPsZW0-tgRsJTHKMjBeQoQHAxbmlE';
    }
}

Vue.use(VueGoogleMaps, {
    load: {
        key: googleMapsApiKey,
        libraries: 'places'
    }
});
Vue.use(VueDragscroll);
Vue.use(VueCarousel);
Vue.use(VueMasonry);
Vue.use(VueResizeText);
Vue.use(VModal);
Vue.use(VueLodash, { name: 'custom', lodash: { chunk, concat } });

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.mixin({
    methods: { websiteText, commonMethod, htmlDecode, blFormatPrice, getMissingImage }
});

Vue.config.ignoredElements = ['model-viewer'];

if (document.getElementById('main')) {
    new Vue({
        components: {
            RetailerSearch,
            ProductTabs,
            Category,
            ResponsiveVideos,
            ResponsiveVideoImage,
            ReadMore,
            ProductListing,
            UpSellProductListing,
            DoorFamilyCategory,
            CatalogOrder,
            FilterSorting,
            FaqList,
            InspirationListing,
            InspirationList,
            ProductListBlock,
            MediaDownloadList,
            MasonryGrid,
            ImageHotspots,
            EnergyLabel,
            NewsTicker,
            RetailerMap,
            RetailerMap2,
            RetailerOpeningHours,
            RetailerMeetingBooking,
            OpenProductTab,
            ContactForm,
            ContactFormV2,
            Outlets,
            References,
            RetailerExhibits,
            ImageWithHotspots,
            BuyButtonContainer,
            Checkout,
            CheckoutB2c,
            CtaInputField,
            OrderConfirmationB2c,
            ReturnForm,
            Configurator,
            ConfigBuyButton,
            Complement,
            Message,
            ProductList,
            ProductImageSlider,
            BlogList,
            DataLayer,
            ProductSampleForm,
            FitsWithDrawer,
            DiscountCodeForm,
            DiscountCodeConsume,
            SimulatorSummary,
            SingleSelectLink,
            ItemsList,
            BusinessCentralLoader,
            BusinessCentralLoaderV2,
            CollapsableMenu,
            VimeoVideoModalToggle,
            EverydayTrafficLight,
            EverydayBar,
            SimpleNewsList,
            MultipleImages,
            ProductQuickReferenceGuide,
            RotCalculator
        },
        directives: {
            VueDragscroll,
            VueCarousel,
            VueResizeText
        },
        router,
        store
    }).$mount('#main');
}

if (document.getElementById('header')) {
    const headerElement = document.getElementById('header');
    let headerId = '#header';
    if (
        headerElement !== undefined &&
        headerElement !== null &&
        headerElement.id !== undefined &&
        headerElement.id !== null
    ) {
        // if (headerElement?.id)
        headerId = headerElement.id;
    }

    new Vue({
        components: {
            RetailerOpeningHours,
            MiniCart,
            QuickSearch,
            CartItemsCount
        },
        directives: {},
        router,
        store
    }).$mount(headerId);
}

if (document.getElementById('footer')) {
    new Vue({
        components: {
            RetailerMap,
            NewsTicker,
            EverydayBar
        },
        directives: {},
        router,
        store
    }).$mount('#footer');
}
